import { Record } from 'immutable';
export var makeMarketplaceAppFlatRatePricingItem = function makeMarketplaceAppFlatRatePricingItem(marketplaceAppPricingItem) {
  return marketplaceAppPricingItem;
};
export var makeMarketplaceAppPerUnitPricingItem = function makeMarketplaceAppPerUnitPricingItem(marketplaceAppPricingItem) {
  return marketplaceAppPricingItem;
};
export var makeMarketplaceAppPricing = Record({
  items: [],
  perUnitItems: undefined
});

var formatAppPricingItem = function formatAppPricingItem(items) {
  return items.map(function (appPricingItem) {
    return {
      monthsValid: appPricingItem.monthsValid,
      unitCount: appPricingItem.unitCount,
      amount: appPricingItem.localCurrencyAmount,
      currencyCode: appPricingItem.localCurrency
    };
  });
};

export var makeMarketplaceAppPricingFromRawAppPricing = function makeMarketplaceAppPricingFromRawAppPricing(rawMarketplaceAppPricing) {
  return makeMarketplaceAppPricing({
    items: formatAppPricingItem(rawMarketplaceAppPricing.items),
    perUnitItems: formatAppPricingItem(rawMarketplaceAppPricing.perUnitItems || [])
  });
};